import 'normalize.css';
import './style.scss';

import ReactDOM from 'react-dom/client';
import App      from '@/App';
import * as Sentry     from '@sentry/react';

Sentry.init({
	enabled: !__LOCAL__,
	dsn: "https://b0f173625eb9a38fecc0bb7105fbd506@o240489.ingest.us.sentry.io/4511376336617472",
	integrations: [
		new Sentry.BrowserTracing({
			tracePropagationTargets: ['localhost', /^https:\/\/.+tokamap/],
		}),
		new Sentry.Replay(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    // Désactivation de React.StrictMode car cela déclenche plusieurs fois les requêtes
    // ce qui entraine des dysfonctionnements avec les resolvable

    // <React.StrictMode>
    <App/>,
    // </React.StrictMode>,
);
